module.exports = __webpack_public_path__ + "static/media/health-main-icon.5b51f02c.svg";